import { render, staticRenderFns } from "./ContentModule.vue?vue&type=template&id=cd2663e8&scoped=true"
import script from "./ContentModule.vue?vue&type=script&lang=js"
export * from "./ContentModule.vue?vue&type=script&lang=js"
import style0 from "./ContentModule.vue?vue&type=style&index=0&id=cd2663e8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2663e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd2663e8')) {
      api.createRecord('cd2663e8', component.options)
    } else {
      api.reload('cd2663e8', component.options)
    }
    module.hot.accept("./ContentModule.vue?vue&type=template&id=cd2663e8&scoped=true", function () {
      api.rerender('cd2663e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/ContentModule.vue"
export default component.exports